"use client";
// @ts-strict-ignore
import { mediaQuery } from "@hubble/web";
import styled, { createGlobalStyle, withTheme } from "styled-components";

export const DynamicContainer = withTheme(styled.div`
  background-color: ${({ theme }) => theme.colorPalette.gray[50]};
`);

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 0px auto;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    max-height: 288px;
    ${({ theme: { media } }) => media.tablet`
    max-height: 451px;
  `};
  }
`;

export const CardContentUl = styled.div`
  width: 100%;
  padding: 0px;
  list-style: none;
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  height: 100%;
  justify-content: flex-start;
  ${({ theme: { media } }) => media.desktop`
  justify-content: center;
  `};
  &.secondaryList {
    margin-top: 30px;
    div {
      height: auto;
      &:first-child {
        margin-bottom: 0px;
      }
    }
    ${({ theme: { media } }) => media.desktop`
      margin-top: 0px;
      `};
  }
  &.socialMedia {
    display: flex;
    flex-direction: row;
    height: auto;
    justify-content: flex-start;
    margin-top: 12px;
  }
`;

export const CardContentUlLi = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  max-width: 622px;
  margin: 0px auto 22px;
  img {
    object-fit: cover;
    margin: 0px 14px 0px 0px;
    display: none;
    width: 120px;
    height: 120px;
    ${({ theme: { media } }) => media.tablet`
  display: block;
  width: 80px;
  height: 80px;
  `};
    ${({ theme: { media } }) => media.desktop`
            margin: 0px 27px 0px 0px;
            `};
  }
  p {
    &.bold {
      font-size: 22px;
      max-width: 226px;
      ${({ theme: { media } }) => media.desktop`
    font-size: 18px;
    max-width: 100%;
    `};
    }
  }
  ${({ theme: { media } }) => media.desktop`
      max-width: 515px;
      `};
`;

export const CardContentBackSubText = styled.div`
  width: 100%;
  max-width: 100%;
  p.bold {
    margin: 0px 0px 1px 0px;
    color: ${({ theme }) => theme.colorPalette.black_secondary};
    font-weight: 600;
    &:first-child {
      padding-top: 10px;
    }
  }
  p {
    margin: 0px;
    color: ${({ theme }) => theme.colorPalette.gray[600]};
  }
`;

export const CardContentBackBox = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  ${({ theme: { media } }) => media.mobileLandscape`
flex-direction: row;
`};
`;
export const CardContentBackLeftPart = styled.div`
  min-width: 180px;
  max-width: 180px;
  text-align: center;
  padding: 25px 5px;
  background-color: ${({ theme }) => theme.colorPalette.light_grey_card};
  border-radius: 100%;
  min-width: 290px;
  max-width: 180px;
  margin-right: auto;
  padding: 62px 5px;
  margin-left: auto;
  max-height: 180px;
  ${({ theme: { media } }) => media.mobileLandscape`
min-width: 180px;
max-width: 180px;
padding: 25px 5px;
margin-right: 48px;
margin-left: 0px;
`};

  .starsCustom {
    color: transparent;
    width: 169.7px;
    height: 34.87px;
    top: -16px;
    position: relative;
    margin-bottom: -10px;
    ${({ theme: { media } }) => media.mobileLandscape`
  width: 125px;
  height: 25px;
  top: -14px;
  `};
  }
  h1 {
    font-weight: 600;
    font-size: 65.203px;
    line-height: 100%;
    letter-spacing: -0.05em;
    color: ${({ theme }) => theme.black_secondary};
    margin: 0px auto 1px auto;
  }
  h2 {
    font-size: 89.0618px;
    line-height: 100%;
    ${({ theme: { media } }) => media.tablet`
  font-size: 65.203px;
  line-height: 100%;
  `};
  }
  p {
    text-align: center;
    margin-bottom: 0px;
    font-size: 14.1663px !important;
    line-height: 120%;
    letter-spacing: -0.01em;
    ${({ theme: { media } }) => media.mobileLandscape`
  font-size: 10.3713px !important;
  line-height: 120%;
  `};
    color: ${({ theme }) => theme.black_secondary};
    margin: 0px;
  }
  svg {
    margin: 0px 2px 0px;
    position: relative;
    top: 1px;
    min-width: 12px;
    height: 14px;
    ${({ theme: { media } }) => media.mobileLandscape`
  min-width: auto;
  height: auto;
  `};
  }
`;

export const GlobalStyle = createGlobalStyle`
  body {
  &.body-fixed{
    overflow: hidden !important;
    position: relative;
    height: 100%;
    touch-action:none;
    overflow-y:hidden !important;
    &:after{
        position: fixed;
        top: 0px;
        left: 0px;
        content: '';
        background-color: white;
        width: 100%;
        height: 100%;
        display: block;
    }
    ${({ theme: { media } }) => media.mobileLandscape`
    overflow-y:visible !important;
    height: auto;
    touch-action: auto;
    &:after{
      display: none;
    }
    `};
  }
    .movedownload{
      opacity: 1;
      z-index: -1;
      box-shadow: 0 7px 30px 2px rgba(0, 0, 0, 0.08);
      position: absolute;
      bottom: 20px;
      right: 20px;
      transition: 1s ease-in-out;
    }
    &.qrCodeDisplay{
      .movedownload{
        position: fixed;
        bottom: 20px;
        opacity: 1;
        z-index: 22;
        right: 20px;
        transition: 1s ease-in-out;
      }
    }
    &.mobileGeminiQr{
      .moveqr{
        position: fixed;
        bottom: 20px;
        opacity: 1;
        z-index: 22;
        right: 20px;
        transition: 1s ease-in-out;
      }
    }
    .flexGrid{
      flex-direction: row;
      max-width: calc(100% - 82px);
      margin-left: auto;
      margin-right: auto;
      @media ${mediaQuery.tabletSmDown} {
        flex-direction: column;
        & > div{
          margin-left: auto;
          margin-right: auto;
          max-width: 650px;
          &:last-child{
            margin-right: auto;
          }
        }
      }
      ${({ theme: { media } }) => media.midSizeDesktop`
      max-width: 1126px;
    `};
    }
    h2.lgHeading{
      font-size: 80px;
      font-style: normal;
      font-weight: 600;
      line-height: 95%;
      letter-spacing: -3.2px;
      max-width: 100%;
      text-align: left;
      margin: 170px auto 60px;
      @media (max-width: 767px){
      font-size: 48px;
      font-style: normal;
      font-weight: 600;
      line-height: 48px;
      letter-spacing: -1.92px;
      max-width: 346px;
      margin: 60px auto 22px;
      }
      h2.customHeading{
        font-size: 60px;
        font-style: normal;
        font-weight: 600;
        line-height: 60px;
        letter-spacing: -2.4px;
        max-width: 653px;
        text-align: center;
        margin: 0px auto 24px;
        span{
          display: inline-block;
        }
      }
      h2.mdHeading{
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 36px; /* 112.5% */
        letter-spacing: -0.96px;
      max-width: 740px;
      text-align: center;
      margin: 54px auto 0px;
      &.heading{
        max-width: 820px;
        margin-top: 103px;
        &.one{
          opacity: 1;
        }
        &.two{
          opacity: 0;
        }
        span{
          display: block;
        }
        @media (max-width: 767px){
          margin-top: 30px;
          padding-left: 12px;
          &.two{
            opacity: 1;
          }
          }
      }
        @media (max-width: 767px){
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
        letter-spacing: -0.72px;
        max-width: 450px;
        text-align: left;
        margin: 37px auto 0px;
        }
        }
`;

export const DownloadText = styled.p`
  margin: 0px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  max-width: 100px;
  color: ${({ theme }) => theme.colorPalette.black};
  text-align: left;
`;

export const DownloadApp = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  max-width: 160px;
  margin: 0px auto 0px;
  background-color: ${({ theme }) => theme.colorPalette.white};
  border-radius: 4px;
  padding: 9.5px 9px 9.5px 16px;
  display: none;
  justify-content: space-between;
  align-items: center;
  ${({ theme: { media } }) => media.tablet`
    display: flex;
  `};
`;

export const CardContentBackText = styled.div`
  width: 100%;
  max-width: 100%;
`;
